import React from 'react';
import type { UserSubmission as UserSubmissionModel } from 'models/projects/UserSubmission';
import type { FormSubmission as FormSubmissionModel } from 'models/projects/FormSubmission';
import { FormViewer } from 'components/forms/FormViewer';
import { TeamReview } from 'models/projects/TeamReview';
import TeamReviewComponent from './teamReviewComponent';

type Props = {
  submission: UserSubmissionModel | FormSubmissionModel;
  className?: string;
  isOwner?: boolean;
  isTeamMember?: boolean;
  projectId: string;
};

const UserSubmission: React.FC<Props> = ({ submission, className = '', isOwner = false, isTeamMember = false, projectId }) => {
  const isFormSubmission = (submission as any)?.type === 'FormSubmission' || !!(submission as any)?.form;

  const form = isFormSubmission ? (submission as FormSubmissionModel).form : null;
  const teamReview = (submission as any).teamReview ?? null;

  return (
    <div className={`flex gap-6 ${className}`}>
      <div className="flex-1">
        {isFormSubmission && form ? (
          <div className="h-full">
            <FormViewer
              form={form}
              formId={form?.id ?? ''}
              isDisabled={true}
            />
          </div>
        ) : (
          <div className="p-4 bg-white border rounded shadow-sm">
            <h3 className="text-base font-semibold mb-2">Submission</h3>
            <pre className="text-xs bg-gray-50 p-3 rounded overflow-auto">{JSON.stringify(submission, null, 2)}</pre>
          </div>
        )}
      </div>

      <div className="w-1/3">
        <div className="p-4 bg-white border rounded shadow-sm">
          <TeamReviewComponent teamReview={teamReview} isOwner={isOwner} isTeamMember={isTeamMember} projectId={projectId} />
        </div>
      </div>
    </div>
  );
};

export default UserSubmission;
